/* import __COLOCATED_TEMPLATE__ from './signup-image-uploader.hbs'; */
import { notEmpty } from '@ember/object/computed';
import Component from '@ember/component';
import { guidFor } from '@ember/object/internals';
import { computed } from '@ember/object';

/** @type {function} */
const noop = () => { };

/** @module */
const SignupImageUploader = Component.extend({
  /** @inheritDoc */
  tagName: '',

  /** @type {boolean} */
  hasError: notEmpty('error'),

  /** @type {boolean} */
  disabled: false,

  /** @type {boolean} */
  loading: false,

  /** @type {string} */
  url: '',

  /** @type {string} */
  imageTypeString: 'profile photo',

  /** @inheritDoc */
  init() {
    this._super(...arguments);
    this.set('inputId', guidFor(this));
  },

  uploadLabel: computed(
    'imageTypeString',
    'url',
    function () {
      if (this.url) {
        return `Change your ${this.imageTypeString}`;
      }

      return `Upload your ${this.imageTypeString}`;
    }
  ),

  /** @inheritDoc */
  actions: {

    /**
     * @param {KeyboardEvent} e
     */
    handleKeyDown(e) {
      switch (e.key) {
        case 'Space':
        case 'Enter':
          e.preventDefault();
          document.getElementById(this.inputId).click();
          break;
      }
    },

    /**
     *
     */
    triggerFileUpload() {
      document.getElementById(this.inputId).click();
    },

    /**
     * @param {} e
     */
    handleFileChange(e) {
      const [file] = e.target.files;
      e.target.value = '';
      this.get('onchange')?.(file);
    },
  },
});

export default SignupImageUploader;
